var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instruction-container",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"instruction-background"}),_c('div',{staticClass:"instruction-box"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.item.inventoryType))]),_c('div',{staticClass:"instruction-text"},[_vm._v(_vm._s(_vm.item.instruction))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }